import { apiGet, APIURL, cancelSelectEvent, getCSSStyles, getHeaderPinButtonHTML, getHeaderPinStateClass, getNoDataHTML, getWidgetDataURI, isHeaderPinned, normalizeWidgetTheme, setupHeaderPin, toggleWidgetTheme } from './../../helpers';
import { WidgetConfig, WidgetEvent, WidgetEventHandler, WidgetEventType } from './../../types';

export class TraderverseBreakdownCountry {
  private container: HTMLElement;
  private config: WidgetConfig;
  private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
  private updateInterval: number | null = null;
  private shadowRoot: ShadowRoot;
  private currentData: any = null;
  private widgetResizeObserver: ResizeObserver | null = null;
  private lastFetchedAt: Date | null = null;
  private selectedCoin: string = 'ethereum';
  private widgetIndex: number = 0;

  constructor(config: WidgetConfig) {
    this.config = { ...this.getDefaultConfig(), ...config };
    this.config.theme = normalizeWidgetTheme(this.config.theme);
    this.container = this.resolveContainer(config.container);

    if ((this.container as any).shadowRoot) {
      this.shadowRoot = (this.container as any).shadowRoot;
    } else {
      this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
    }
    this.init();

    this.widgetResizeObserver = new ResizeObserver(() => {
      this.updateDisplay();
    });
    setTimeout(() => {
      const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
      if (widget) this.widgetResizeObserver?.observe(widget);
    }, 0);
  }


  private fetchSymbols(): Array<{ value: string; label: string }> {
    return [
      { label: 'AAPL', value: 'AAPL' }, { label: 'MSFT', value: 'MSFT' },
      { label: 'GOOGL', value: 'GOOGL' }, { label: 'AMZN', value: 'AMZN' },
      { label: 'NVDA', value: 'NVDA' }, { label: 'META', value: 'META' },
      { label: 'TSLA', value: 'TSLA' }, { label: 'AVGO', value: 'AVGO' },
      { label: 'PEP', value: 'PEP' }, { label: 'COST', value: 'COST' }
    ];
  }

  private getDefaultConfig(): Partial<WidgetConfig> {
    const symbols = this.fetchSymbols();
    return {
      headerPinned: true,
      symbol: symbols[0].value,
      theme: 'default-dark',
      width: '100%',
      height: '400px',
      autosize: true
    };
  }

  private resolveContainer(container: string | HTMLElement): HTMLElement {
    if (typeof container === 'string') {
      const el = document.getElementById(container) || document.querySelector(container);
      if (!el) throw new Error(`Container not found: ${container}`);
      return el as HTMLElement;
    }
    return container;
  }

  private async init(): Promise<void> {
    if (!this.config.symbol) this.config.symbol = this.fetchSymbols()[0].value;

    this.createWidget();
    const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    if (widget) widget.classList.add('loading');
    this.attachStyles();
    await this.setupChart();
    if (widget) widget.classList.remove('loading');
    this.emit('ready', {});
    this.config.onReady?.();
    cancelSelectEvent(this.shadowRoot);
  }

  private createWidget(): void {
    const hasData = !!this.currentData?.data?.companyGroup?.length;
    let themeClass = 'defaultDarkMode';
    let dataTheme = 'default-dark';
    
    if (this.config.theme === 'white') {
      themeClass = 'whiteMode';
      dataTheme = 'white';
    } else if (this.config.theme === 'black') {
      themeClass = 'blackMode';
      dataTheme = 'black';
    } else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}
    const widgetHtml = `
      <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width};height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-testing-id="breakdown-country-widget-${this.widgetIndex}" data-theme="${dataTheme}">
        <div class="headTop">
          <h4 class="title crypto">${this.getTitleIconSvg()} Countries Breakdown</h4>
            <div class="actionCol">${getHeaderPinButtonHTML(this.config)}<tooltip-wrapper id="lastUpdatedTooltip"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.625 6.625C0.625 7.41293 0.780195 8.19315 1.08172 8.9211C1.38325 9.64905 1.82521 10.3105 2.38236 10.8676C2.93951 11.4248 3.60095 11.8667 4.3289 12.1683C5.05685 12.4698 5.83707 12.625 6.625 12.625C7.41293 12.625 8.19315 12.4698 8.9211 12.1683C9.64905 11.8667 10.3105 11.4248 10.8676 10.8676C11.4248 10.3105 11.8667 9.64905 12.1683 8.9211C12.4698 8.19315 12.625 7.41293 12.625 6.625C12.625 5.0337 11.9929 3.50758 10.8676 2.38236C9.74242 1.25714 8.2163 0.625 6.625 0.625C5.0337 0.625 3.50758 1.25714 2.38236 2.38236C1.25714 3.50758 0.625 5.0337 0.625 6.625Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/> <path d="M6.625 3.2915V6.62484L8.625 8.62484" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/> </svg><tooltip><span>Last Updated</span><strong>N/A</strong></tooltip></tooltip-wrapper><i class="pi pi-ellipsis-v"></i></div>
        </div>

        <div class="inBody">

          <div class="optionsRow">
            <div id="bdbcHead" class="item padHt openWidth"></div>
            <span></span>
            <div class="item tabsDv padHt coinTabs">
                <select class="coinDropdown" id="coinSelect">
                    <option value="ethereum" ${this.selectedCoin === 'ethereum' ? 'selected' : ''}>Ethereum</option>
                    <option value="bitcoin" ${this.selectedCoin === 'bitcoin' ? 'selected' : ''}>Bitcoin</option>
                </select>
            </div>
          </div>


          <div class="chartDv bdbcMain" id="bdbcContainer" style="height: 100%; padding: 0; margin: 0;"></div>

        </div>
      </div>
    `;

    this.shadowRoot.innerHTML = widgetHtml;
    setupHeaderPin(this.shadowRoot, this.config);

      const select = this.shadowRoot.querySelector('.coinDropdown') as HTMLSelectElement;
      if (select) {
        select.value = this.selectedCoin;
        select.addEventListener('change', () => {
          const coin = (select.value || '').toLowerCase();
          if (coin) this.setSelectedCoin(coin);
        });
      }

      this.setupChart();
  }

  private async attachStyles(): Promise<void> {
    try {
      const styleEl = await getCSSStyles();
      this.shadowRoot.appendChild(styleEl);
    } catch (err) {
      console.error('Failed to load CSS file:', err);
    }
  }

  private async setupChart(): Promise<void> {
    const widgetBox = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    try {
      const response = await apiGet({
        method: 'GET',
        url: `${APIURL}/v1/crypto/crypto_company_treasury`,
        headers: { 'Content-Type': 'application/json' }
      });

      if (!response.ok) throw new Error("Failed to fetch data");
      this.currentData = await response.json();
      const fromApi = (this.currentData as any)?.last_updated_at ?? (this.currentData as any)?.data?.[0]?.last_updated_at;
      this.lastFetchedAt = fromApi ? new Date(fromApi) : new Date();
      
      if (!this.currentData?.data?.companyGroup || this.currentData?.data?.companyGroup.length === 0) {
        widgetBox?.removeAttribute('data-testing-id');
      }
      
      this.updateDisplay();
      this.emit('dataUpdate', this.currentData);
    } catch (err) {
      console.error("Error fetching chart data:", err);
      widgetBox?.removeAttribute('data-testing-id');
    }
  }

  private formatPrice(value: number): string {
    if (value >= 1_000_000_000) {
        return (value / 1_000_000_000).toFixed(2) + 'B';
    } else if (value >= 1_000_000) {
        return (value / 1_000_000).toFixed(2) + 'M';
    } else if (value >= 1_000) {
        return (value / 1_000).toFixed(2) + 'K';
    } else {
        return value.toFixed(2);
    }
  }

  private renderCountriesBreakdown(): void {
    const container = this.shadowRoot.querySelector('#bdbcContainer');
    const headContainer = this.shadowRoot.querySelector('#bdbcHead');
    const widgetBox = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    if (!container || !headContainer || !this.currentData?.data?.companyGroup || !this.currentData?.data?.coinGroup) return;

    const coinIdRaw = this.selectedCoin || 'ethereum';
    const coinData = this.currentData.data.coinGroup.find((c: any) => c._id === coinIdRaw);

    let ethCardHTML = '';
    if (coinData) {
      ethCardHTML = `
        <div class="cryptoCard">
          <h2>Total ${coinData._id} Supply Held</h2>
          <div class="valueWrapper">
            <h3>$${this.formatPrice(coinData.total_current_value_usd)} / $${this.formatPrice(coinData.total_entry_value_usd)}</h3>
            <span class="positive">${coinData.percentage_of_total_supply.toFixed(3)}% (24h)</span>
          </div>
        </div>
      `;
    } else {
      ethCardHTML = `
        <div class="cryptoCard">
          <h2>${coinIdRaw.charAt(0).toUpperCase() + coinIdRaw.slice(1)} data not available</h2>
        </div>
      `;
    }

    const countryMap: Record<string, number> = {};
    const coinId = (this.selectedCoin || 'ethereum').toLowerCase();
    const companyGroup = this.currentData.data.companyGroup || [];
    let relevantCompanies = companyGroup.filter((item: any) => ((item.coin_id || '') as string).toLowerCase() === coinId);
    if (!relevantCompanies || relevantCompanies.length === 0) {
      relevantCompanies = companyGroup;
    }

    relevantCompanies.forEach((item: any) => {
      const country = item.country;
      const value = item.total_current_value_usd || 0;

      if (!countryMap[country]) countryMap[country] = 0;
      countryMap[country] += value;
    });

    const totalValue = Object.values(countryMap).reduce((a, b) => a + b, 0);
    
    if (totalValue === 0) {
      widgetBox?.removeAttribute('data-testing-id');
      container.innerHTML = getNoDataHTML();
      return;
    }
    
    const breakdownData: { country: string, percent: number, color: string }[] = [];
    let othersTotal = 0;
    Object.entries(countryMap).forEach(([country, value]) => {
      const percent = (value / totalValue) * 100;
      if (['US', 'JP', 'CN'].includes(country)) {
        const color = country === 'US' ? '#b8860b' : country === 'JP' ? '#6a5acd' : '#008080';
        breakdownData.push({ country, percent, color });
      } else {
        othersTotal += percent;
      }
    });

    if (othersTotal > 0) {
      breakdownData.push({ country: 'Others', percent: othersTotal, color: '#808080' });
    }

    headContainer.innerHTML = ethCardHTML;
    let html = ''; 

    html += `<div class="countriesBreakdownContainer">`;
    breakdownData.forEach(item => {
      html += `
        <div class="countryItem">
          <div class="countryLabel">${item.country}</div>
          <div class="barAndPercent">
            <span style="width: ${item.percent}%; background-color: ${item.color};"></span>
            <p>${item.percent.toFixed(2)}%</p>
          </div>
        </div>
      `;
    });
    html += `</div>`;
if (this.currentData?.data?.companyGroup?.length) {
  (container as HTMLElement).setAttribute(
    'data-testing-id',
    `bdbc-container-${this.widgetIndex}`
  );
} else {
  (container as HTMLElement).removeAttribute('data-testing-id');
}
    container.innerHTML = html;
  }

  private formatLastUpdated(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/New_York',
    };
    return date.toLocaleString('en-US', options).replace(',', '').replace(/\//g, '-') + ' EST';
  }

  private updateLastUpdatedTooltip(): void {
    const lastUpdated = this.lastFetchedAt ? this.formatLastUpdated(this.lastFetchedAt) : 'N/A';
    const tooltip = this.shadowRoot.querySelector('#lastUpdatedTooltip tooltip strong');
    if (tooltip) tooltip.innerHTML = lastUpdated.replace(' ', '<br>');
  }

  private updateDisplay(): void {
    this.updateLastUpdatedTooltip();
    if (!this.currentData) {
      setTimeout(() => this.updateDisplay(), 100);
      return;
    }
    this.renderCountriesBreakdown();
  }

  public on(type: WidgetEventType, handler: WidgetEventHandler): void {
    if (!this.eventHandlers.has(type)) this.eventHandlers.set(type, []);
    this.eventHandlers.get(type)!.push(handler);
  }

  public off(type: WidgetEventType, handler: WidgetEventHandler): void {
    const list = this.eventHandlers.get(type);
    if (list) this.eventHandlers.set(type, list.filter(h => h !== handler));
  }

  public setSymbol(symbol: string): void {
    this.config.symbol = symbol;
    this.setupChart();
  }

  public async getWidgetImage(): Promise<string> {
    const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    return await getWidgetDataURI(widget);
  }
  
  public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
    if (!this.shadowRoot) return;
  
    this.config.theme = toggleWidgetTheme(
      this.shadowRoot,
      theme
    ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';
  
    this.updateDisplay();
  }

  public setSelectedCoin(coin: string): void {
    this.selectedCoin = coin;
    this.updateDisplay();
  }

  public destroy(): void {
    if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
    if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
    this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
  }

  private emit(type: WidgetEventType, data: any): void {
    const handlers = this.eventHandlers.get(type);
    if (handlers) { const evt: WidgetEvent = { type, data }; handlers.forEach(h => h(evt)); }
  }
  private getTitleIconSvg(): string {
    return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.15 20.3C12.3125 20.3 10 17.9875 10 15.15C10 12.3125 12.3125 10 15.15 10C17.9875 10 20.3 12.3125 20.3 15.15C20.3 17.9875 18 20.3 15.15 20.3ZM15.15 11.8625C13.3375 11.8625 11.875 13.3375 11.875 15.1375C11.875 16.9375 13.35 18.4125 15.15 18.4125C16.95 18.4125 18.425 16.9375 18.425 15.1375C18.425 13.3375 16.9625 11.8625 15.15 11.8625Z" fill="currentColor"/> <path d="M15 28.4375C7.5875 28.4375 1.5625 22.4125 1.5625 15C1.5625 7.5875 7.5875 1.5625 15 1.5625C22.4125 1.5625 28.4375 7.5875 28.4375 15C28.4375 22.4125 22.4125 28.4375 15 28.4375ZM15 3.4375C8.625 3.4375 3.4375 8.625 3.4375 15C3.4375 21.375 8.625 26.5625 15 26.5625C21.375 26.5625 26.5625 21.375 26.5625 15C26.5625 8.625 21.375 3.4375 15 3.4375Z" fill="currentColor"/> <path d="M15.0625 22C14.5158 22 14.0625 21.5192 14.0625 20.9394V9.06061C14.0625 8.48081 14.5158 8 15.0625 8C15.6092 8 16.0625 8.48081 16.0625 9.06061V20.9394C16.0625 21.5192 15.6092 22 15.0625 22Z" fill="currentColor"/> </svg>`;
  }

}

declare global { interface Window { TraderverseBreakdownCountry: typeof TraderverseBreakdownCountry; } }
if (typeof window !== 'undefined') { window.TraderverseBreakdownCountry = TraderverseBreakdownCountry; }